import { useState } from 'react';
import axios from 'axios';
import { getToken } from 'utils/crypto';
import { getFreshFileUrl } from './getFreshFileUrl';

export const DownloadFile = () => {
    const [loadDownload, setLoadDownload] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    const handleDownload = async (file, id) => {
        if (id) {
            setCurrentId(id);
        }

        const resolved = file?.file?.key ? file.file : file;
        const fileName = resolved?.originalName || file?.name || '';

        if (!resolved?.key && !resolved?.url) {
            setCurrentId(null);
            return;
        }

        setLoadDownload(true);
        try {
            const downloadUrl = await getFreshFileUrl(file, { disposition: 'attachment' });

            if (!downloadUrl) {
                setLoadDownload(false);
                setCurrentId(null);
                return;
            }

            const response = await axios({
                url: downloadUrl,
                method: 'GET',
                responseType: 'blob',
                useBaseUrl: false,
            });
            setLoadDownload(false);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (e) {
            setLoadDownload(false);
        } finally {
            setCurrentId(null);
        }
    };

    const download1500Form = async (file, id) => {
        setLoadDownload(true);
        axios({
            url: `/claim/${id}/1500Form`,
            method: 'GET',
            responseType: 'blob',
            headers: { 'access-token': `${getToken()}` },
        })
            .then((response) => {
                setLoadDownload(false);
                const url = window.URL.createObjectURL(new Blob([response?.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `1500Form.pdf`);
                document.body.appendChild(link);
                link.click();
            })
            .catch(() => {
                setLoadDownload(false);
            });
    };

    const download1500Forms = async (id) => {
        setLoadDownload(true);
        axios({
            url: `/claim/batch/${id}/1500Forms`,
            method: 'GET',
            responseType: 'blob',
            headers: { 'access-token': `${getToken()}` },
        })
            .then((response) => {
                setLoadDownload(false);
                const url = window.URL.createObjectURL(new Blob([response?.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `1500Form.pdf`);
                document.body.appendChild(link);
                link.click();
            })
            .catch(() => {
                setLoadDownload(false);
            });
    };
    const downloadBatch = async (id) => {
        setLoadDownload(true);
        axios({
            url: `/reports/payroll/batch/${id}`,
            method: 'GET',
            responseType: 'blob',
            headers: { 'access-token': `${getToken()}` },
        })
            .then((response) => {
                setLoadDownload(false);
                const url = window.URL.createObjectURL(new Blob([response?.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `processedPayroll.csv`);
                document.body.appendChild(link);
                link.click();
            })
            .catch(() => {
                setLoadDownload(false);
            });
    };

    return {
        loadDownload,
        handleDownload,
        download1500Form,
        download1500Forms,
        downloadBatch,
        currentId,
    };
};
